import {
  MostSearchedProceduresQueryDocument,
  MostSearchedProceduresQueryQuery,
} from '@medprev-web-app/api-graphql-client';

import { ApolloClient } from '@/graphql/apollo-client';
import { MostSearchedResultType, SearchType } from '@/types/most-search-type';
import { mostSearchedGroupLabels } from '@/services/most-searched/most-searched-group-labels.const';

type MostSearchedGroupResponse = MostSearchedProceduresQueryQuery['mostSearchedProcedures'][number];

function toMostSearchedResult(group: MostSearchedGroupResponse): MostSearchedResultType {
  const type = String(group.type) as SearchType;

  return {
    ...mostSearchedGroupLabels[type],
    type,
    procedures: group.procedures.map((procedure) => ({
      id: String(procedure.id),
      code: procedure.code,
      name: procedure.name,
      displayName: procedure.displayName,
      slug: procedure.slug,
      alias: procedure.alias,
      searchTerm: procedure.searchTerm,
      type: String(procedure.type) as SearchType,
    })),
  };
}

export async function getMostSearchedGroups(): Promise<MostSearchedResultType[]> {
  const { data } = await ApolloClient.query({
    query: MostSearchedProceduresQueryDocument,
  });

  return (data?.mostSearchedProcedures ?? []).map(toMostSearchedResult);
}

export async function getMostSearchedProcedures(): Promise<MostSearchedResultType[]> {
  const groups = await getMostSearchedGroups();

  return groups.filter((group) => group.type !== SearchType.VACCINE);
}
